import { Outlet } from "react-router-dom";
import { SyncRoleFromUrl } from "./CheckRole";

const RoleLayout = () => {
  return (
    <>
      <SyncRoleFromUrl /> 
      <Outlet />           
    </>
  );
};

export default RoleLayout;
